
String.prototype.IsEmpty = (string)=>{
    return string === "" ? true :false;
}
module.exports = String;